import React, {Component} from 'react';
import './Intro.css';

const Feature = props => {
  const featureStyles = {
    background: 'url(' + props.introData.feature_image + ')',
    backgroundSize: 'cover',
    backgroundPosition: '24% 50%'
  };
  return (
    <div className="Feature">
      <div className="Feature-container">
        <div className="Feature-image">
          <div className="Feature-image-container">
            <div className="Feature-image-bg" style={ featureStyles }>
              <div className="sr-only">Image of bright colors swirling around the exterior facade of the V-C-U Institute for Contemporary Art</div>
            </div>
          </div>
        </div>
        <div className="Feature-title">{props.introData.feature_title}</div>
      </div>
    </div>
  );
}

class Intro extends Component {
  render() {
    const { introData } = this.props;
    const introStyles = {
      background: 'url(' + introData.image + ')',
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%'
    };

    return (
      <div className="Intro">
        <Feature
          introData={ introData }
        />
        <div className="Intro-container">
          <div className="Intro-text">
            <div className="Intro-text-container" dangerouslySetInnerHTML={{__html: introData.text}}></div>
          </div>
          <div className="Intro-image">
            <div className="Intro-image-container">
              <div className="Intro-image-placeholder" style={ introStyles }>
                <div className="sr-only">Portrait of V-C-U President Michael Rao</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Intro;


// WEBPACK FOOTER //
// ./src/components/Intro/Intro.js